<template>
  <div
    class="account-select-container shadow"
    v-clickoutside="hideAccountSelecter"
  >
    <img class="account-bg" v-if="userbg" :src="userbg" alt="moduleBg" />
    <div class="account-info">
      <img
        class="account-avatar"
        v-if="userAvatar"
        :src="userAvatar"
        alt="game-logo"
      />
      <div class="role-info-text">
        <p class="role ellipsis" v-if="roleName">{{ roleName }}</p>
        <p class="account ellipsis">{{ userName }}</p>
      </div>
      <div
        v-if="!isInWebview"
        class="role-switch flex-center btn-wrap j-role-switch"
        @click="handleGoLogOut"
      >
        <span class="role-switch-text">{{ letter.logout }}</span>
      </div>
    </div>
    <div class="account-btn-list">
      <div class="account-btn" @click="accountHandle('coupon')">
        <Icon class="account-btn-ico" name="ticket" />
        <p class="account-btn-text">{{ letter.v3MyCoupons }}</p>
        <em class="red-dot" v-if="showRedDot"></em>
      </div>
      <div
        v-if="visibleRights"
        class="account-btn"
        @click="accountHandle('vip')"
      >
        <Icon class="account-btn-ico" name="vip" />
        <p class="account-btn-text">{{ letter.v3BenefitsCenter }}</p>
      </div>
      <div
        v-if="showTimeAwardList.length"
        class="account-btn"
        @click="accountHandle('activity')"
      >
        <Icon class="account-btn-ico" name="time" />
        <p class="account-btn-text">{{ letter.limitedTimeActivityTitle }}</p>
      </div>
      <button class="more flex-center" @click="accountHandle('more')">
        {{ letter.v3MoreSettings }}
        <Icon class="more-ico" name="double-right"></Icon>
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import account from '@mixins/officialTopupNew/account';
import globalConfig from '@utiles/officialStore/globalConfig';
import clickOutside from '../../diractives/officialStore/clickOutside';
import {
  clickButton,
  locationType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV35';
export default {
  name: 'accountSelecter',
  mixins: [account],
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      gameId: state => state.gameId,
      loginAccount: state => state.login.loginAccount,
      displayName: state => state.login.displayName,
      rightsLink: state => state.page.rightsLink,
      picList: state => state.page.picList,
      isInWebview: state => state.isInWebview,
      gameCouponEnableList: state => state.coupon.gameCouponEnableList
    }),
    ...mapGetters(['showTimeAwardList']),
    userAvatar() {
      return this.picList?.avatar;
    },
    userbg() {
      return this.picList?.userbg;
    },
    userName() {
      // 20240725 需求人: 邓智轩 特殊处理：顽星域名账号展示隐藏前缀 以DISPLAY_NAME字段作为账号显示名称
      if (globalConfig.getMainHost() === 'playplanetgame.com') {
        return this.displayName;
      } else {
        return this.loginAccount;
      }
    },
    showRedDot() {
      return this.gameCouponEnableList?.length > 0;
    }
  },
  methods: {
    handleGoLogOut() {
      clickButton({
        btnName: 'logout',
        locationKey: locationType.accountInfo
      });
      this.goLogOut();
    }
  },
  directives: {
    clickoutside: clickOutside
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.account-select-container {
  margin-top: 20px;
  position: absolute;
  top: 100px;
  z-index: -1;
  width: 100%;
  box-sizing: border-box;
  border-radius: 0 0 20px 20px;
  padding: 40px 60px;
  background-color: #ffffff;

  .account-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-height: 100%;
    object-fit: cover;
    object-position: top center;
    border-radius: 0 0 20px 20px;
  }

  .account-info {
    position: relative;
    display: flex;
    align-items: center;

    .account-avatar {
      flex-shrink: 0;
      width: 68px;
      height: 68px;
      border-radius: 50%;
      margin-right: 20px;
    }

    .role-info-text {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      flex-shrink: 0;
      color: #333333;
      overflow: hidden;

      .role {
        font-size: 24px;
        font-weight: bold;
        line-height: 1.5;
      }

      .account {
        font-size: 20px;
        line-height: 1.5;
      }

      .ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .role-switch {
      flex-shrink: 0;
      min-width: 80px;
      max-width: 120px;
      height: fit-content;
      background-color: #ffffff;
      border-radius: 9px;
      padding: 20px;
      border: solid 1px #e8e8e8;
      cursor: pointer;

      .role-switch-text {
        font-size: 22px;
        color: #333333;
      }
    }
  }

  .account-btn-list {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 40px;

    .account-btn {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 80px;
      background-color: #ffffff;
      border-radius: 20px;
      border: solid 1px #e8e8e8;
      cursor: pointer;

      .account-btn-ico {
        position: absolute;
        margin: 0 20px;
        width: 40px;
        height: 40px;
        color: $themeColor;
      }

      .account-btn-text {
        line-height: 1.2;
        padding: 0 80px;
        text-align: center;
        flex: 1;
        font-size: 20px;
        color: #333333;
      }
    }
    .account-btn + .account-btn {
      margin-top: 22px;
    }
    .more {
      margin-top: 33px;
      font-size: 22px;
      color: #333333;
      .more-ico {
        margin-left: 5px;
        width: 20px;
        height: 20px;
      }
    }
  }
  .red-dot {
    display: block;
    position: absolute;
    right: -2px;
    top: -2px;
    width: 16px;
    height: 16px;
    background-color: #ff2800;
    border-radius: 50%;
  }
}
#ssr-page.landscape {
  .account-select-container {
    width: 500px;
    right: 0;
    margin: auto;
    .account-info {
      .account-avatar {
        margin-right: 10px;
      }
      .role-info-text {
        .role {
          font-size: 20px;
        }
        .account {
          font-size: 16px;
        }
      }
      .role-switch {
        min-width: 60px;
        max-width: 90px;
        padding: 10px 15px;
        margin-left: 10px;

        .role-switch-text {
          font-size: 20px;
          color: #333333;
        }
      }
    }
  }
}
</style>
